module.exports = __webpack_public_path__ + "img/prize_cup.86a9afe8.gif";